import PermissionGate from './PermissionGate';

export default PermissionGate;
